<template>
  <div class="view">
    <div class="content">
      <h2 class="ui inverted header">Reset password</h2>
      <sui-segment :loading="loading">
        <sui-form :error="hasError" @submit.prevent="submit">
          <sui-form-field>
            <sui-input type="password" ref="password" v-model.trim="password" placeholder="New password" icon="lock" icon-position="left" autocomplete="new-password" required />
          </sui-form-field>
          <sui-button size="large" color="blue" fluid>Update</sui-button>
          <sui-message error>
            {{error}}
          </sui-message>
        </sui-form>
      </sui-segment>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import utils from '@/utils'

  export default {
    name: 'AccountRecoveryConfirm',
    data() {
      return {
        password: '',
        loading: false,
        error: null,
      }
    },
    computed: {
      hasError() {
        return Boolean(this.error)
      },
    },
    methods: {
      submit() {
        utils.reachGoal('USER_RESET_NEWPASS')
        const {email, recoveryId} = this.$route.query
        if (email && recoveryId && this.password) {
          this.loading = true
          this.error = null
          api.recoveryConfirm(email, recoveryId, this.password).then(() => {
            utils.reachGoal('USER_RESET_SUCCESS')
            this.$router.push('/user/recoveryEnd')
          }).catch(error => {
            utils.reachGoal('USER_RESET_FAIL')
            this.error = error
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.error = 'Something went wrong'
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.password.$refs.input.focus()
      })
    },
  }
</script>

<style scoped>
  .view { display: flex; align-items: center; justify-content: center; text-align: center; }
</style>
